
const lastUpdate = '2026-03-15';
export const helpTitle = 'CFFDRS Startup Wizard';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The CFFDRS Startup Wizard starts or stops Canadian Forest Fire Danger Rating System calculations on a weather station. CFFDRS must be started each season with appropriate initial values.</p>

<h2>Starting CFFDRS</h2>

<h3>Spring Mode</h3>
<p>Use Spring Mode when starting CFFDRS at the beginning of the fire season. Standard default values are applied automatically:</p>
<ul>
  <li><strong>FFMC:</strong> 85</li>
  <li><strong>DMC:</strong> 6</li>
  <li><strong>DC:</strong> 15</li>
</ul>
<p>These values are appropriate for typical spring snowmelt conditions.</p>

<h3>Summer Mode</h3>
<p>Use Summer Mode when restarting CFFDRS mid-season (e.g., after an extended outage). Enter custom values based on current conditions:</p>
<ul>
  <li>Enter FFMC, DMC, and DC values manually.</li>
  <li>Use the <strong>Overwinter DC Calculator</strong> if you need to derive DC from post-winter conditions using the Lawson &amp; Dalrymple (1996) method.</li>
</ul>

<h2>Overwinter DC Calculator</h2>
<p>The Overwinter DC Calculator estimates the spring DC value based on the previous season's closing DC and precipitation over the dormant period. It uses the Lawson &amp; Dalrymple (1996) method.</p>
<ul>
  <li>The <strong>Closing DC Lookup</strong> finds the cold snap event at the end of the previous fire season — this is used as the starting point for the overwinter calculation.</li>
</ul>

<h2>Stopping CFFDRS</h2>
<p>Click <strong>Stop</strong> to end CFFDRS calculations for the season. The wizard will record the <strong>closing DC value</strong> so it can be retrieved by the Overwinter DC Calculator next spring.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
